// 神仙形象图和头像映射
import caishenImg from './assets/gods/caishen.webp';
import caishenAvatar from './assets/gods/caishen_avatar.webp';
import guanyinImg from './assets/gods/guanyin.webp';
import guanyinAvatar from './assets/gods/guanyin_avatar.webp';
import wenquxingImg from './assets/gods/wenquxing.webp';
import wenquxingAvatar from './assets/gods/wenquxing_avatar.webp';
import xishenImg from './assets/gods/xishen.webp';
import xishenAvatar from './assets/gods/xishen_avatar.webp';
import yuelaoImg from './assets/gods/yuelao.webp';
import yuelaoAvatar from './assets/gods/yuelao_avatar.webp';
import zaowangyeImg from './assets/gods/zaowangye.webp';
import zaowangyeAvatar from './assets/gods/zaowangye_avatar.webp';

// 神仙完整形象图
export const GOD_IMAGES: Record<string, string> = {
  xishen: xishenImg,
  caishen: caishenImg,
  yuelao: yuelaoImg,
  zsnn: guanyinImg,       // 注生娘娘使用观音形象
  szgy: guanyinImg,       // 送子观音
  wqx: wenquxingImg,      // 文曲星
  kx: wenquxingImg,       // 魁星使用文曲星形象
  zy: zaowangyeImg,       // 灶王爷
  tdg: zaowangyeImg,      // 土地公使用灶王爷形象（暂无独立素材）
};

// 神仙头像
export const GOD_AVATARS: Record<string, string> = {
  xishen: xishenAvatar,
  caishen: caishenAvatar,
  yuelao: yuelaoAvatar,
  zsnn: guanyinAvatar,
  szgy: guanyinAvatar,
  wqx: wenquxingAvatar,
  kx: wenquxingAvatar,
  zy: zaowangyeAvatar,
  tdg: zaowangyeAvatar,
};

export { xishenImg, xishenAvatar };
